import * as React from 'react';
import type {Duration} from 'src/types/scheduler';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  BodySmall,
  BodySmallBold,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TimelineItem} from '@spaced-out/ui-design-system/lib/components/Timeline';
import {getDurationLabel} from 'src/components/scheduler/utils';
import css from './sequential-booking-info.css';


interface BreakTimelineItemProps {
  breakInfo: {amount: number; unit: string};
  index: number;
}

export const BreakTimelineItem = ({
  breakInfo,
  index,
}: BreakTimelineItemProps) => {
  const {t} = useLabelTranslation();

  return (
    <TimelineItem
      children={null}
      key={`break-${index}`}
      classNames={{
        icon: css.timelineItemIcon,
      }}
      iconColor="neutral"
      iconName="mug-saucer"
      iconType="regular"
      enableCardWrapper={false}
      title={
        <BodySmallBold color="secondary">{t('Break', 'Break')}</BodySmallBold>
      }
      description={
        <BodySmall color="secondary">
          {breakInfo ? getDurationLabel(breakInfo as Duration, t) : null}
        </BodySmall>
      }
    />
  );
};
